import Constants from 'expo-constants';
import * as Updates from 'expo-updates';
import { StyleSheet, View } from 'react-native';
import { Text } from '../../../components/primitives/Text';
import { colors } from '../../../theme/colors';
import { tokens } from '../../../theme/tokens';

// Understated build identifier shown at the bottom of the Settings screen.
// Useful for end-user bug reports — operators can correlate the displayed
// build with the Releases dashboard in admin.
export function VersionFooter() {
  const appVersion = Constants.expoConfig?.version ?? 'unknown';
  const runtimeVersion = Updates.runtimeVersion ?? 'embedded';
  const updateIdShort = Updates.updateId ? Updates.updateId.slice(0, 8) : null;

  const line = updateIdShort
    ? `v${appVersion} · ${runtimeVersion} · ${updateIdShort}`
    : `v${appVersion} · ${runtimeVersion}`;

  return (
    <View
      style={styles.container}
      accessibilityRole="text"
      accessibilityLabel={`Application version ${line}`}
    >
      <Text variant="caption" color={colors.text.tertiary} style={styles.text}>
        {line}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: tokens.spacing.md,
    paddingHorizontal: tokens.spacing.lg,
    alignItems: 'center',
  },
  text: {
    fontSize: 11,
    letterSpacing: 0.3,
    opacity: 0.6,
  },
});
